export const getMachines = (state) => {
  return state.machines;
};
